// extracted by mini-css-extract-plugin
export var fontBold = "D_4Nyh9bHz37RCbWaR0u";
export var fontMedium = "dGUjCHgqSpBT7tcHjiJl";
export var fontRegular = "mISnlaG3nXwjnjemEN3w";
export var fontSemiBold = "iWU1IbMlCkm7GQXS6JWg";